// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2iEwG","col":"CardReaderDesc_col__2t3Ch","label":"CardReaderDesc_label__1KfkL"};